import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-dni-confirmation',
  templateUrl: './dni-confirmation.component.html',
  styleUrls: ['./dni-confirmation.component.css'],
})
export class DniConfirmationComponent {
  @Input() identityData: any;
  @Output() confirmed = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }
}
